import {
    SprayApplicationRate,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { OwnProps } from './index';
import { HECTARE } from '../../../ProductRatePerUnitTypeDropdown/constants';

const selectUnits = (state: AppState, props: OwnProps): number =>
    (props.product && props.product.units) || 0;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): SprayProductPerUnitType => props.product && props.product.perUnitType;

const selectApplicationRate = (
    state: AppState,
    props: OwnProps
): SprayApplicationRate => props.applicationRate;

const selectRatePerHundredLitre = createDeepEqualSelector(
    selectUnits,
    selectPerUnitType,
    selectApplicationRate,
    makeSelectUnitTypeFieldValue('name'),
    (units, perUnitType, applicationRate, unitTypeName) => {
        const unitType = unitTypeName || '';

        if (perUnitType === HECTARE) {
            return `${Number((units * 100) / applicationRate).toFixed(
                2
            )} ${unitType}`;
        }

        return `${units} ${unitType}`;
    }
);

const makeSelectRatePerHundredLitre = (): typeof selectRatePerHundredLitre =>
    selectRatePerHundredLitre;

export { makeSelectRatePerHundredLitre };
